var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 11.8133 19.5533 13.4867 18.66 15.02C17.7667 16.5533 16.5533 17.7667 15.02 18.66C13.4867 19.5533 11.8133 20 10 20C8.18667 20 6.51333 19.5533 4.98 18.66C3.44667 17.7667 2.23333 16.5533 1.34 15.02C0.446667 13.4867 0 11.8133 0 10C0 8.18667 0.446667 6.51333 1.34 4.98C2.23333 3.44667 3.44667 2.23333 4.98 1.34C6.51333 0.446667 8.18667 0 10 0C11.8133 0 13.4867 0.446667 15.02 1.34C16.5533 2.23333 17.7667 3.44667 18.66 4.98C19.5533 6.51333 20 8.18667 20 10ZM17.66 10C17.66 7.89333 16.91 6.09 15.41 4.59C13.91 3.09 12.1067 2.34 10 2.34C8.32 2.34 6.81333 2.83333 5.48 3.82L16.18 14.52C17.1667 13.1867 17.66 11.68 17.66 10ZM14.52 16.18L3.82 5.48C2.83333 6.81333 2.34 8.32 2.34 10C2.34 12.1067 3.09 13.91 4.59 15.41C6.09 16.91 7.89333 17.66 10 17.66C11.68 17.66 13.1867 17.1667 14.52 16.18Z",
    fill: "#F69E1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableIcon);
export default __webpack_public_path__ + "static/media/disable-icon.f8aa39789449d57663eeba9da7b9a748.svg";
export { ForwardRef as ReactComponent };